import { render, staticRenderFns } from "./KorisnikBase.vue?vue&type=template&id=adb23a20&scoped=true&"
import script from "./KorisnikBase.vue?vue&type=script&lang=js&"
export * from "./KorisnikBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb23a20",
  null
  
)

export default component.exports